import LogoCarousel from "../../../../components/CarouselLogos/CarouselLogos";
import useWindowSize from "../../../../hooks/useWindowSize";
import "./Confiance.scss";

const partners = [
  {
    name: "kemika",
    img: "/images/logo-confiance/logo-kemika.png",
  },
  {
    name: "unger",
    img: "/images/logo-confiance/unger.png",
  },
  {
    name: "Tork-Logo",
    img: "/images/logo-confiance/Tork-Logo.png",
  },
  {
    name: "propre-odeur",
    img: "/images/logo-confiance/propre-odeur.png",
  },
  {
    name: "laboratoire-rochex",
    img: "/images/logo-confiance/laboratoire-rochex.png",
  },
  {
    name: "logo-action-pin",
    img: "/images/logo-confiance/logo-action-pin.png",
  },
  {
    name: "sico",
    img: "/images/logo-confiance/sico.png",
  },
  {
    name: "Numatic",
    img: "/images/logo-confiance/Numatic.png",
  },
  {
    name: "CONCEPT-MICROFIBRE_LOGO",
    img: "/images/logo-confiance/CONCEPT-MICROFIBRE_LOGO.png",
  },
  {
    name: "sylvania",
    img: "/images/logo-confiance/sylvania.png",
  },
  {
    name: "filmop-logo",
    img: "/images/logo-confiance/filmop-logo.png",
  },
  {
    name: "exeol",
    img: "/images/logo-confiance/exeol.png",
  },
  {
    name: "logo-truvox",
    img: "/images/logo-confiance/logo-truvox.png",
  },
  {
    name: "sopromode",
    img: "/images/logo-confiance/sopromode.png",
  },
  {
    name: "deb-logo",
    img: "/images/logo-confiance/deb-logo.png",
  },
  {
    name: "SC_Johnson",
    img: "/images/logo-confiance/SC_Johnson.png",
  },
  {
    name: "duplex",
    img: "/images/logo-confiance/duplex.png",
  },
  {
    name: "elco",
    img: "/images/logo-confiance/elco.png",
  },
  {
    name: "jofel",
    img: "/images/logo-confiance/jofel.png",
  },
  {
    name: "prodifa",
    img: "/images/logo-confiance/prodifa.png",
  },
  {
    name: "LOGHI_BRAND_LUCART",
    img: "/images/logo-confiance/LOGHI_BRAND_LUCART.png",
  },

  {
    name: "eltex",
    img: "/images/logo-confiance/eltex.png",
  },
  {
    name: "koolnet",
    img: "/images/logo-confiance/koolnet.png",
  },
  {
    name: "Logo_Ghibli_Wirbel",
    img: "/images/logo-confiance/Logo_Ghibli_Wirbel.png",
  },
  {
    name: "logo-hygiene-nature",
    img: "/images/logo-confiance/logo-hygiene-nature.png",
    style: {
      width: "7%",
    },
  },
  {
    name: "comac",
    img: "/images/logo-confiance/comac.png",
    style: {
      width: "8%",
    },
  },
  {
    name: "Logo-tvx-cleaning-france",
    img: "/images/logo-confiance/Logo-tvx-cleaning-france.png",
    style: {
      width: "8%",
    },
  },
  {
    name: "idospng",
    img: "/images/logo-confiance/idospng.png",
    style: {
      width: "7%",
    },
  },

  {
    name: "probbax-logo",
    img: "/images/logo-confiance/probbax-logo.png",
  },
];

const Confiance = () => {
  const { width } = useWindowSize();
  return (
    <div className="list-confiance">
      <div>
        <p>ILS NOUS FONT CONFIANCE</p>
      </div>
      {width > 1100 ? (
        <div>
          <div>
            {partners.slice(0, 7).map((partner) => (
              <img
                key={partner.name}
                src={partner.img}
                alt={partner.name}
                style={partner?.style}
              />
            ))}
          </div>
          <div>
            {partners.slice(7, 14).map((partner) => (
              <img
                key={partner.name}
                src={partner.img}
                alt={partner.name}
                style={partner?.style}
              />
            ))}
          </div>
          <div>
            {partners.slice(14, 21).map((partner) => (
              <img
                key={partner.name}
                src={partner.img}
                alt={partner.name}
                style={partner?.style}
              />
            ))}
          </div>
          <div>
            {partners.slice(21, 29).map((partner) => (
              <img
                key={partner.name}
                src={partner.img}
                alt={partner.name}
                style={partner?.style}
              />
            ))}
          </div>
        </div>
      ) : (
        <LogoCarousel logos={partners} />
      )}
    </div>
  );
};

export default Confiance;
